import { render, staticRenderFns } from "./ActiveProviders.vue?vue&type=template&id=3ed689c0&"
import script from "./ActiveProviders.vue?vue&type=script&lang=js&"
export * from "./ActiveProviders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports